<template>
    <v-content>
        <v-layout>
            <v-flex xs12>
                <v-layout justify-space-between px-12 pa-4>
                    <v-layout>
                        <v-flex shrink mr-3 style="text-align: center;">
                            <img alt="Vue logo" src="../assets/logo.png" style="width: 60px;cursor: pointer;" @click="$router.push('/home').catch(err => {})">
                        </v-flex>
                        <v-flex shrink class="mt-1" style="text-align: left;cursor: pointer;" @click="$router.push('/home').catch(err => {})">
                            ฐานข้อมูลกลาง<br>
                            <b>คุณลักษณะเฉพาะสิ่งอุปกรณ์สายแพทย์</b>
                        </v-flex>
                    </v-layout>

                    <v-flex shrink class="mt-4" style="text-align: right;color: #527281;">
                        <b>ชื่อผู้ใช้งาน :</b> {{first_name}} {{last_name}}
                        <v-menu offset-y bottom left id="menuFormHome">
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on">
                                    <v-icon style="color: #527281">brightness_5</v-icon>
                                </v-btn>
                            </template>
                            <v-list id="menulistHome">
                                <v-layout py-2 px-4 style="background-color: #E5E5E5; text-align: left">
                                    <v-flex>
                                        <span>ข้อมูลส่วนตัว</span>
                                    </v-flex>
                                </v-layout>
                                <v-list-item-title
                                        class="menu-list-home"
                                        @click="$router.push('/order-history').catch(err => {})"
                                >
                                    <div style="border-bottom: 1px solid #E5E5E5; text-align: left;cursor: pointer;">
                                        <v-flex class="my-1 mx-4">
                                            <v-icon class="mr-4">library_books</v-icon>
                                            <span style="font-size: 12px;">ประวัติการสั่งซื้อ</span>
                                        </v-flex>
                                    </div>
                                </v-list-item-title>
                                <v-list-item-title
                                        class="menu-list-home"
                                        @click="$router.push('/edit-profile-user').catch(err => {})"
                                >
                                    <div style="border-bottom: 1px solid #E5E5E5; text-align: left;cursor: pointer;">
                                        <v-flex class="my-1 mx-4">
                                            <v-icon class="mr-4">edit</v-icon>
                                            <span style="font-size: 12px;">แก้ไขโปรไฟล์</span>
                                        </v-flex>
                                    </div>
                                </v-list-item-title>
                                <v-list-item-title
                                        class="menu-list-home"
                                        @click="$router.push('/change-password-user').catch(err => {})"
                                >
                                    <div style="border-bottom: 1px solid #E5E5E5; text-align: left;cursor: pointer;">
                                        <v-flex class="my-1 mx-4">
                                            <v-icon class="mr-4">lock</v-icon>
                                            <span style="font-size: 12px;">แก้ไขรหัสผ่าน</span>
                                        </v-flex>
                                    </div>
                                </v-list-item-title>
                                <v-list-item-title
                                        class="menu-list-home"
                                        @click="$router.push('/help').catch(err => {})"
                                >
                                    <div style="border-bottom: 1px solid #E5E5E5; text-align: left;cursor: pointer;">
                                        <v-flex class="my-1 mx-4">
                                            <v-icon class="mr-4">help</v-icon>
                                            <span style="font-size: 12px;">ช่วยเหลือ</span>
                                        </v-flex>
                                    </div>
                                </v-list-item-title>
                                <v-list-item-title
                                        class="menu-list-home"
                                        @click="logout()"
                                >
                                    <div style="border-bottom: 1px solid #E5E5E5; text-align: left;cursor: pointer;">
                                        <v-flex class="my-1 mx-4">
                                            <v-icon class="mr-4">exit_to_app</v-icon>
                                            <span style="font-size: 12px;">ออกจากระบบ</span>
                                        </v-flex>
                                    </div>
                                </v-list-item-title>
                            </v-list>
                        </v-menu>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-content>
</template>

<script>
    import { mapState } from "vuex";

    export default {
        name: "Header",
        first_name: '',
        last_name: '',
        data: () => ({
            items: [
                {title: 'ประวัติการสั่งซื้อ', icon: 'library_books', route: 'order-history'},
                {title: 'แก้ไขโปรไฟล์', icon: 'edit', route: 'edit-profile-user'},
                {title: 'แก้ไขรหัสผ่าน', icon: 'lock', route: 'change-password-user'},
                {title: 'ช่วยเหลือ', icon: 'help', route: 'help'},
                {title: 'ออกจากระบบ', icon: 'exit_to_app', route: '/'},
            ],
        }),
        created() {
            // console.log(this.dataUser)
            this.check_login();
            this.first_name = this.dataUser.firstname;
            this.last_name = this.dataUser.lastname;
        },
        computed: {
            // Map Vuex state.
            ...mapState({
                dataUser: stat => {
                  return stat.Auth.user
                },
            })
        },
        methods: {
            check_login() {
                this.$store.dispatch('Auth/setUser')
                    .then(data => {
                    })
                    .catch(err => {
                        alert('กรุณาลงชื่อเข้าสู่ระบบ')
                        this.$router.push('/')
                    })
            },
            logout() {
                this.$store.dispatch('Auth/logout').then(() => {
                    this.$router.push('/')
                })

            }
        }
    }
</script>

<style lang="scss">
    .theme--light.v-list#menulistHome {
        padding-top: 0;
        padding-bottom: 0;
    }

    .v-menu__content.theme--light.menuable__content__active#menuFormHome {
        left: unset !important;
    }

    .v-list-item#listItemHome {
        padding: 0px !important;
    }

    .menu-list-home:hover {
        background: rgba(224, 216, 209, 0.15);
    }
</style>
